module.exports = __webpack_public_path__ + "static/media/logo-tipy.2586895c.png";